module.exports = __webpack_public_path__ + "img/404.11832a8f.svg";